import { useCreateCustomerMutation } from '@/common/infrastructure/gql/generated/schema';
import { mapFormDataToCreateInput } from '../mappers/CustomerMappers';
import { CustomerFormData } from '../types/CustomerTypes';

export const useCreateCustomer = () => {
  const [createCustomerMutation, { loading, error }] = useCreateCustomerMutation();

  const handleCreateCustomer = async (formData: CustomerFormData) => {
    try {
      const { data } = await createCustomerMutation({
        variables: {
          customer: mapFormDataToCreateInput(formData)
        },
        refetchQueries: ['listCustomers', 'listCustomersAutocomplete']
      });
      return data?.createCustomer?.value;
    } catch (error) {
      // Let Apollo error handling manage the error state
      throw error;
    }
  };

  return { handleCreateCustomer, loading, error };
};
